import React from 'react';
import { PDFDownloadLink, Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';
import logo from "Assets/images/logo.png";
import { globalStyles } from "config/pdfStyles";
import { dateFormat, getAge } from "helpers/common";
import { INTAKE_TEAM_EMAIL } from "config/constants";
import KhanReportLogoPdf from 'components/shared/KhanReportLogoPdf';

// Create styles
const styles = StyleSheet.create({
  header: {
    alignItems: "center",
    justifyContent: "center",
    // textAlign: "center"
  },
  logo: {
    width: "20%",
  },
  templateHeading: {
    fontSize: "15px",
    marginBottom: "10px",
  },
  templateContainer: {
    flexDirection: "column",
  },
  templateField: {
    paddingVertical: "10px",
  },
  table: {
    flexDirection: "column"
  },
  tableRow: {
    flexDirection: "row",
    borderBottom: "1px solid #ddd",
    paddingVertical: "5px",
  },
  tableHead: {
    ...globalStyles.fontBold,
    width: "25%",
    // border: "1px solid #ddd",
  },
  tableColumn: {
    width: "25%",
    fontSize: "14px"
    // border: "1px solid #ddd"
  },
  questionHeading: {
    ...globalStyles.fontBold,
    fontSize: "14px",
    marginBottom: "5px",
  }
});

// Create Document Component
export const IntakeReportDoc = ({ data, answers, questions }) => {
  return (
    <Document>
      <Page size="A4" style={globalStyles.page}>
        <View style={[globalStyles.section, styles.header]}>
          <Image
            style={styles.logo}
            src={logo}
          />
        </View>
        <View style={globalStyles.section}>
          <View style={styles.table}>
            <View style={styles.tableRow}>
              <Text style={styles.tableHead}>Last Name</Text>
              <Text style={styles.tableColumn}>{data?.lastname}</Text>

              <Text style={styles.tableHead}>First Name</Text>
              <Text style={styles.tableColumn}>{data?.firstname}</Text>
            </View>
            <View style={styles.tableRow}>
              <Text style={styles.tableHead}>Birth Date:</Text>
              <Text style={styles.tableColumn}>{dateFormat(data?.client_detail?.dob)}</Text>

              <Text style={styles.tableHead}>Chronological Age:</Text>
              <Text style={styles.tableColumn}>{getAge(data?.client_detail?.dob)}</Text>
            </View>
            {data?.client_detail?.client_guardian_mapping?.length > 0 &&
              data?.client_detail?.client_guardian_mapping?.map(
                (guardian, index) => {
                  const slug = guardian?.client_guardian?.client_role?.slug;
                  if (slug !== "parent") {
                    return null;
                  }

                  return (
                    <View style={[styles.tableRow, { flexDirection: "column", borderBottom: "none" }]}>
                      <Text style={styles.tableHead}>Parent {index + 1}</Text>
                      <View style={[styles.tableRow, { borderBottom: "none" }]}>
                        <Text style={styles.tableHead}>Last Name:</Text>
                        <Text style={styles.tableColumn}>{guardian?.client_guardian?.lastname}</Text>

                        <Text style={styles.tableHead}>First Name</Text>
                        <Text style={styles.tableColumn}>{guardian?.client_guardian?.firstname}</Text>
                      </View>
                      <View style={styles.tableRow}>
                        <Text style={styles.tableHead}>Email:</Text>
                        <Text style={styles.tableColumn}>{guardian?.client_guardian?.email}</Text>
                      </View>
                    </View>
                  );
                }
              )}
            <View style={styles.tableRow}>
              <Text style={styles.tableHead}>Date of Intake:</Text>
              <Text style={styles.tableColumn}>{dateFormat(data?.client_detail?.client_home_education_detail?.intake_date)}</Text>

              <Text style={styles.tableHead}>Grade:</Text>
              <Text style={styles.tableColumn}>{data?.client_detail?.grade}</Text>
            </View>

          </View>
        </View>
        {questions?.length > 0 && questions.map((question, index) => {
          let answer = answers && answers[question?.id]?.answer;
          return (
            <View key={index} style={[globalStyles.section]}>
              <Text style={styles.questionHeading}>
                {question.question}
              </Text>
              <Text style={{ fontSize: "12px" }}>
                {answer}
              </Text>
            </View>
          )
        })}
        <View style={globalStyles.section}>
          <Text style={{ fontSize: "12px" }}>
            The intake team may be contacted at: {INTAKE_TEAM_EMAIL}
          </Text>
        </View>

        {/* Branding */}
        <View style={globalStyles.section}>
          <KhanReportLogoPdf />
        </View>
      </Page>
    </Document>
  )
};
